import {Link} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import React from 'react';
import {Redirect} from 'react-router-dom';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Header} from 'semantic-ui-react';

import {AccessDenied} from '../components/AccessDenied';
import {LOGIN_PATH} from '../routes/auth/authPaths';
import {useViewer} from '../state/viewer/hooks';
import {setAuthRedirect} from '../util/auth';
import {isInIframe} from '../util/window';

interface NoMatchProps {
  unrecoverable?: boolean;
}

// We are deprecating NoMatch in favor of the pages/NoAccessPage
const NoMatch: React.FC<NoMatchProps> = ({unrecoverable}) => {
  const viewer = useViewer();
  const loggedIn = viewer != null;

  const helpMessage = loggedIn
    ? 'If this is the right URL, you might need to ask the page owner to change the privacy permissions or invite you to the team.'
    : 'If this is the right URL, you might need to log in or ask the page owner to change the privacy permissions.';

  const buttonText = loggedIn ? 'Go to home page' : 'Log in to W&B';

  const queryParams = new URLSearchParams(window.location.search);
  const authRedirect = queryParams.get('authRedirect');
  const redirectTo = window.location.href.replace(window.location.origin, '');

  // Determine button link based on login status
  const buttonLink = loggedIn
    ? `/`
    : {
        pathname: LOGIN_PATH,
        state: {
          prompt: true,
          from: {pathname: redirectTo},
          internal: true,
        },
      };

  // Handle click for unauthenticated users
  const handleLoginClick = () => {
    if (!loggedIn) {
      setAuthRedirect(redirectTo);
    }
  };
  if (!loggedIn && authRedirect) {
    setAuthRedirect(redirectTo);
    return (
      <Redirect
        to={{
          pathname: LOGIN_PATH,
          state: {
            prompt: true,
            from: {pathname: redirectTo},
            internal: true,
          },
        }}
      />
    );
  }

  return isInIframe() ? (
    <AccessDenied unrecoverable={unrecoverable} />
  ) : (
    <div className="nomatch">
      <Header>404</Header>
      <h2>Looks like you stumbled on an empty page.</h2>
      <p>{helpMessage}</p>
      <Link to={buttonLink} newTab={false} onClick={handleLoginClick}>
        <Button variant="primary">{buttonText}</Button>
      </Link>
    </div>
  );
};

export default NoMatch;
